import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import Notification from '@tds/core-notification';

import { getPathVariables } from '../../misc';

import {
  DueMonthlyWrapper,
  DueNowWrapper,
  ButtonsWrapper,
  Button,
  Flex,
  LabelDueMonthly,
  BeforeTaxesLabel,
  PricingBlockMain,
  IntegralPart,
  FractionalPart,
  Currency
} from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const Desktop = ({
  isFormTouched,
  dueMonthly,
  dueNow,
  onSaveAndExit,
  onSubmit,
  hidePricing,
  formErrors
}) => {
  const localizedStringsContext = useLocalizedStringsContext();
  const {
    ORDERS: { DUE_MONTHLY, DUE_NOW, BEFORE_TAXES, saveAndContinueLater },
    formButtons: { submitButtonLabel }
  } = localizedStringsContext;

  const [showFooterError, setShowFooterError] = useState(false);

  const getFormattedPricing = pricing => {
    const newPricing = pricing.replace('$', '');
    const locale = getPathVariables(window.location.pathname)[0];
    return (
      <>
        <IntegralPart>
          {newPricing.split('.')[0]}
          <FractionalPart>
            {locale === 'fr-CA' ? ',' : '.'}
            {newPricing.split('.')[1]}
          </FractionalPart>
        </IntegralPart>
        <Currency style={{ order: locale === 'fr-CA' ? '3' : '-1' }}>
          $
        </Currency>
      </>
    );
  };

  useEffect(() => {
    setShowFooterError(Object.keys(formErrors).length > 0);
  }, [formErrors]);

  return (
    <div id="footer-high">
      <>
        <DueMonthlyWrapper>
          <div>
            <LabelDueMonthly>{DUE_MONTHLY}</LabelDueMonthly>{' '}
            {hidePricing ? (
              <p>Impacted by contract</p>
            ) : (
              <>
                <PricingBlockMain>
                  {getFormattedPricing(dueMonthly)}
                </PricingBlockMain>
                <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
              </>
            )}
          </div>
        </DueMonthlyWrapper>
        <DueNowWrapper>
          <>
            <div>
              <LabelDueMonthly>{DUE_NOW}</LabelDueMonthly>
              {hidePricing ? (
                <p>Impacted by contract</p>
              ) : (
                <>
                  <PricingBlockMain>
                    {getFormattedPricing(dueNow)}
                  </PricingBlockMain>
                  <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
                </>
              )}
            </div>
          </>
        </DueNowWrapper>
        <ButtonsWrapper>
          <Flex>
            <Button>
              <button
                type="button"
                onClick={e => onSaveAndExit(e)}
                className="frg-button color-purple"
                disabled={!isFormTouched}
              >
                <span>{saveAndContinueLater}</span>
              </button>
            </Button>
            <Button>
              <button
                type="button"
                onClick={e => onSubmit(e)}
                className="frg-button color-green"
              >
                <span>{submitButtonLabel}</span>
              </button>
            </Button>
          </Flex>
        </ButtonsWrapper>
        {showFooterError && (
          <div style={{ display: 'inline-block' }}>
            <Notification
              variant="error"
              copy="en"
              dismissible
              onDismiss={() => setShowFooterError(false)}
            >
              Please fill out all required fields
            </Notification>
          </div>
        )}
      </>
    </div>
  );
};

Desktop.propTypes = {
  isFormTouched: PropTypes.bool.isRequired,
  dueMonthly: PropTypes.string.isRequired,
  dueNow: PropTypes.string.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool.isRequired,
  formErrors: PropTypes.shape({}).isRequired
};

export default Desktop;
